module.exports = __webpack_public_path__ + "img/bkk-fogas-logo.9f3c3801.svg";